<div class="panel panel-primary">
  <div class="row align-items-center pb-2">

    <div class="col-sm-auto pb-2">
      <div class="form-group form-group-sm">
        <label for="dataInicio" class="form-label">Data Início</label>
        <div class="input-group input-group-sm">
          <input class="form-control" placeholder="dd-MM-yyyy" id="dataInicio" style="color: black;"
            [(ngModel)]="dataInicio" ngbDatepicker #di="ngbDatepicker" required
            (ngModelChange)="selectDataInicio(dataInicio)" pattern="[0-9]{4}[-][0-9]{2}[-][0-9]{2}">
          <button class="btn btn-sm btn-outline-secondary" (click)="di.toggle()" type="button">
            <img src="/assets/images/calendar-icon.svg" style="width: 1.0rem; height: 1rem; cursor: pointer;" />
          </button>
        </div>
      </div>
    </div>

    <div class="col-sm-auto pb-2">
      <div class="form-group form-group-sm">
        <label for="dataFim" class="form-label">Data Fim</label>
        <div class="input-group input-group-sm">
          <input class="form-control" placeholder="dd-MM-yyyy" id="dataFim" style="color: black;" [(ngModel)]="dataFim"
            ngbDatepicker #df="ngbDatepicker" required (ngModelChange)="selectDataFim(dataFim)"
            pattern="[0-9]{4}[-][0-9]{2}[-][0-9]{2}">
          <button class="btn btn-sm btn-outline-secondary" (click)="df.toggle()" type="button">
            <img src="/assets/images/calendar-icon.svg" style="width: 1.0rem; height: 1rem; cursor: pointer;" />
          </button>
        </div>
      </div>
    </div>

    <div class="col-sm-2 pb-2">
      <div class="form-group form-group-sm">
        <label for="numContrato" class="form-label">Nº Contrato</label>
        <div class="input-group input-group-sm">
          <input type="text" style="color: black;text-transform: uppercase;" class="form-control" id="numContrato"
            [(ngModel)]="filter.numContrato" />
        </div>
      </div>
    </div>

    <div class="col-sm-2 pb-2">
      <div class="form-group form-group-sm">
        <label for="matricula" class="form-label">Matrícula</label>
        <div class="input-group input-group-sm">
          <input type="text" style="color: black;text-transform: uppercase;" class="form-control" id="matricula" [(ngModel)]="filter.matricula" />
        </div>
      </div>
    </div>

    <div class="col-sm-2 pb-2">
      <div class="form-group form-group-sm">
        <label for="numChassis" class="form-label">Nº Chassis</label>
        <div class="input-group input-group-sm">
          <input type="text" style="color: black;" class="form-control" id="numChassis" [(ngModel)]="filter.numChassis" />
        </div>
      </div>
    </div>

  </div>
</div>
